import { Card, Skeleton } from '@/_components';
import { SectionHeadingSkeleton } from '@/_containers';

export default function SupportListLoading({ listItemCount = 5 }: { listItemCount?: number }) {
  return (
    <>
      <SectionHeadingSkeleton withIcon={false} />

      <div className="mt-6 mb-2 flex items-end justify-between gap-2">
        <Skeleton className="h-10 w-72 rounded-xl" />
        <Skeleton className="h-10 w-28 rounded-xl" />
      </div>

      <div className="space-y-2">
        {Array.from({ length: listItemCount }).map((_, index) => (
          <Card
            key={index}
            className="flex flex-row items-center gap-4 rounded-none bg-white px-4 py-3 dark:bg-gray-950"
          >
            {/* Avatar skeleton - matching 44x44px size */}
            <Skeleton className="h-11 w-11 shrink-0 rounded-full" />

            {/* Main Content skeleton */}
            <div className="min-w-0 flex-1 space-y-1.5">
              {/* Status badge skeleton */}
              <Skeleton className="h-5 w-12 rounded-sm" />

              {/* Title and ID skeleton */}
              <div className="flex flex-row items-center gap-1.5">
                <Skeleton className="h-5 w-64 rounded" />
                <Skeleton className="h-4 w-8 rounded" />
              </div>

              {/* Metadata skeleton */}
              <div className="flex flex-row items-center gap-1">
                <Skeleton className="h-4 w-24 rounded" />
                <Skeleton className="h-1 w-1 rounded-full" />
                <Skeleton className="h-4 w-20 rounded" />
                <Skeleton className="h-1 w-1 rounded-full" />
                <Skeleton className="h-4 w-16 rounded" />
              </div>
            </div>

            {/* Right column skeleton */}
            <div className="flex min-w-[120px] shrink-0 flex-col items-end gap-0.5">
              <Skeleton className="h-6 w-24 rounded" />
              <Skeleton className="h-6 w-24 rounded" />
              <Skeleton className="h-6 w-24 rounded" />
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}
